// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YSZg","right":"styles_right__3RAXm"};